import React, {Component} from 'react'
import {getBaseDomain} from "../../../utils"

export default class ChatLogItemMotd extends Component {

    componentDidMount() {
        let links = this._ref.querySelectorAll("a");
        if(links && links.length) {
            Array.prototype.forEach.call(links, function (anchor) {
                if (!anchor.target) {
                    anchor.target = "_blank";
                }
            });
        }
    }

    render() {
        let {message} = this.props;

        let messageHtml = message.motd ? message.motd : message;

        return (
            <div className="message motd" ref={(ref) => this._ref = ref}>
                {messageHtml ? <div className="text" dangerouslySetInnerHTML={{__html:messageHtml}}></div> : null}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ChatLogItemMotd/index.js